import React, {useState} from "react";
import CustomDialog from "../../../core/components/ui/CustomDialog";
import {Typography, Box, CircularProgress, FormControl, InputLabel, Select, MenuItem, TextField} from "@mui/material";
import { useDeviceManagement } from "../hooks/useDeviceManagement";
import CustomDialogLoaderComponent from "../../../core/components/common/custom-dialog-loader.component";

const UpdateEntryTypeDialog = (props) => {
    const {open, setOpen, selectedDevice} = props;

    const {updateEntryType, isUpdatingEntryType} = useDeviceManagement();

    const [entry_type, setEntryType] = useState("");

    
    const handleClose = () => {
        setOpen(false);
    }

    const handleSelectedEntry = (e) => {
        setEntryType(e.target.value)
        console.log('get selected entry', e.target.value)
    }

    const handleUpdateStatus = () => {

        const parameters ={
            deviceId: selectedDevice?.device_id,
            entryType: entry_type,
        }

        updateEntryType(parameters, setOpen)

    }

    const actions = [
        {
            label: "Update",
            onClick: (e) => 
                (handleUpdateStatus(e))
        }
    ]

    const globalSx = {
       //
    }


    return (
        <>
            <CustomDialog
                open={open}
                onClose={ handleClose}
                title={<Typography sx={{fontWeight: 500}}>Update Entry Type</Typography>}
                hasDividers={true}
                content={
                    <Box sx={{pl: 2, pr: 2}}>
                        <Typography sx={{fontWeight: 600, mt: 2, fontSize: 15}}>
                            Entry Type
                        </Typography>
                        <FormControl fullWidth >
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                defaultValue={selectedDevice?.entry_type}
                                onChange={handleSelectedEntry}
                            >
                                <MenuItem value="IN">IN</MenuItem>
                                <MenuItem value="OUT">OUT</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                }
                actions={actions}
                maxWidth={"sm"}
                customStyles={{
                    // actions: {
                    //     opacity: (selectedStatus || selectedEntryType && !isUpdatingDevice) ? "100%" : "55%",
                    //     cursor: (selectedStatus || selectedEntryType && !isUpdatingDevice) ? "pointer" : "not-allowed !important",
                        // visibility: (isUpdatingDevice) ? "hidden" : "visible",
                    // }
                }}
                globalSx={globalSx}
            />
        </>
    )
}

export default UpdateEntryTypeDialog
